import { MinLength, MaxLength } from "class-validator";
import {
    validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
    IsDate, Min, Max
} from "class-validator";
import { ValidateIf, IsNotEmpty, IsNumber, IsString, IsEmpty } from "class-validator";


export class Mtrwd {
    @MaxLength(10, { message: 'COMPANY 字串太長' })
    @IsString({ message: 'COMPANY 不是字串型態' })
    COMPANY: string = "";

    @MaxLength(10)
    CREATOR: string = "";

    @MaxLength(10)
    USR_GROUP: string = "";

    @MaxLength(8)
    CREATE_DATE: string = "";

    @MaxLength(10)
    MODIFIER: string = "";

    @MaxLength(8)
    MODI_DATE: string = "";

    @IsNumber()
    @Max(999)
    FLAG: number = 0;


    @IsNotEmpty({ message: '建檔時間 (WD001) 不可空白' })
    @MaxLength(20, { message: '建檔時間 (WD001) 資料太長' })
    WD001: string = '';            // 建檔時間 20 **

    @IsNotEmpty({ message: '工作日期 (WD002) 不可空白' })
    @MaxLength(8, { message: '工作日期 (WD002) 資料太長' })
    WD002: string = '';            // 工作日期 8 **

    WD003: string = '';            // 內文 0 **

    @MaxLength(100, { message: '主旨 (WD004) 資料太長' })
    WD004: string = '';            // 主旨 100 

    @MaxLength(8, { message: '提醒日期 (WD005) 資料太長' })
    WD005: string = '';            // 提醒日期 8 

    @MaxLength(6, { message: '提醒時間 (WD006) 資料太長' })
    WD006: string = '';            // 提醒時間 6 

    @MaxLength(1, { message: '提醒碼 (WD010) 資料太長' })
    WD010: string = 'N';            // 提醒碼 1 

    @MaxLength(1, { message: '狀態 (WD011) 資料太長' })
    WD011: string = '1';            // 狀態 1 ** [DEF:"1"] {{1.未開始 2.進行中   3.等待某人 4.延期 9.已完成}}

    @MaxLength(1, { message: '優先順序 (WD012) 資料太長' })
    WD012: string = '5';            // 優先順序 1 ** [DEF:"5"] 1..9

    @IsNumber()
    WD013: number = 0;            // 進度 3 [DEF:0]   1..100

    @MaxLength(10, { message: '工作者 (WD014) 資料太長' })
    WD014: string = '';            // 工作者 10 ** default UserID

    @MaxLength(10, { message: '大分類 (WD015) 資料太長' })
    WD015: string = 'W';            // 大分類 10 

    @MaxLength(10, { message: '中分類 (WD016) 資料太長' })
    WD016: string = '';            // 中分類 10 

    @MaxLength(1, { message: '結案碼 (WD017) 資料太長' })
    WD017: string = 'N';            // 結案碼 1 ** [DEF:"N"]

    @MaxLength(2, { message: '星期 (WD018) 資料太長' })
    WD018: string = '';            // 星期 2 **

    @IsNumber()
    WD019: number = 0;            // 金額 8 [DEF:0]

    @IsNumber()
    WD020: number = 0;            // 預估時數 8.2 **

    @IsNotEmpty({ message: '客戶代號 (WD021) 不可空白' })
    @MaxLength(10, { message: '客戶代號 (WD021) 資料太長' })
    WD021: string = '';            // 客戶代號 10 ** 使用者

    @MaxLength(1, { message: '私人的 (WD022) 資料太長' })
    WD022: string = 'N';            // 私人的 1 ** [DEF:"N"]  951203 add

    @MaxLength(1, { message: '週期 (WD023) 資料太長' })
    WD023: string = 'N';            // 週期 1 [DEF:"N"] {{D:每日 W:每週 M:每月}}

    @MaxLength(20, { message: '小分類 (WD024) 資料太長' })
    WD024: string = '';            // 小分類 20 

    @IsNumber()
    WD025: number = 0;            // 計費時數 8.2 **

    WD026: string = '';            // RTF內文 0 

    @MaxLength(1, { message: '星號 (WD027) 資料太長' })
    WD027: string = 'N';            // 星號 1 [DEF:"N"]

    @MaxLength(60, { message: '來源單號 (WD028) 資料太長' })
    WD028: string = '';            // 來源單號 60 


}
